// extracted by mini-css-extract-plugin
export default {"errorColor":"ErrorDecorator_errorColor__L2hwc","mediumView":"ErrorDecorator_mediumView__1vPQZ","smallView":"ErrorDecorator_smallView__31Pb4"};